import {GLOBAL_KEYBOARD_SHORTCURS, PAGE_DEPENDENT_KEYBOARD_SHORTCUTS} from './keyboard_shortcuts_service.constants';

export default class KeyboardShortcutsModalService {

	constructor(JFrogModal, JFrogEventBus, $rootScope) {
		this.modal = JFrogModal;
		this.$rootScope = $rootScope;
		this.jFrogEventBus = JFrogEventBus;
	}

	/**
	 *  launch the confirmation modal
	 */
	showhSortcutsModal() {
		this.modalScope = this.$rootScope.$new();
		this.modalScope.globalShortcuts = GLOBAL_KEYBOARD_SHORTCURS;
		this.modalScope.pageDependentShortcuts = PAGE_DEPENDENT_KEYBOARD_SHORTCUTS;
		if (!$('.shortcuts-modal').length) {
			this.modalInstance = this.modal.launchModalWithTemplateMarkup(require('./keyboard_shortcuts_service.modal.html'),
				this.modalScope, 800, false);
		}
	}
}


// WEBPACK FOOTER //
// ./services/keyboard_shortcuts_service/keyboard_shortcuts_service.js